import React from 'react';
import styled from 'styled-components';
import AlertMessage from '../../../components/individualPortal/dashboard/AlertMsgs/AlertMessage';

interface StyledAccordionContainerProps {
    children: React.ReactNode;
    hasAccordionPanelFixedPadding?: boolean;
}

export const StyledAccordionContainer = styled.div<StyledAccordionContainerProps>`
    margin-bottom: 1rem;

    & > * {
        border: 0px;
    }
    .header-container {
        background-color: ${({ theme }) => theme.gray10};
        border-radius: 0px;
        padding: 0px 1%;
        letter-spacing: 1px;
    }

    .content {
        border-top: 0px;
        background-color: ${({ theme }) => theme.white};
        padding-left: ${({ hasAccordionPanelFixedPadding }) => (hasAccordionPanelFixedPadding ? '1%' : '0')};
        padding-right: ${({ hasAccordionPanelFixedPadding }) => (hasAccordionPanelFixedPadding ? '1%' : '0')};
        padding-bottom: ${({ hasAccordionPanelFixedPadding }) => (hasAccordionPanelFixedPadding ? '1%' : '0')};
    }

    .toggle-icon {
        text-decoration: none;
        color: ${({ theme }) => theme.primaryDark};
    }
`;

export const StyledTemplateContainer = styled.div`
    display: flex;
    gap: 1rem;
    width: 100%;
    justify-content: center;
`;

export const StyledSection = styled.section`
    display: flex;
    flex-direction: column;
    column-gap: 1rem;
    flex: 1;
`;

export const StyledDl = styled.dl`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 0.5rem;
    column-gap: 2rem;
`;

export const StyledDt = styled.dt`
    font-weight: bold;
    text-align: right;
    white-space: nowrap;
    align-self: center;
`;

export const StyledWrappedDt = styled(StyledDt)`
    white-space: wrap;
`;

export const StyledDd = styled.dd`
    margin: 0;
    text-align: left;
    display: flex;
    align-items: center;
    align-self: center;
`;

export const StyledCentered = styled.div`
    display: flex;
    justify-content: center;
`;

export const StyleViewBenefitContainer = styled(StyledCentered)`
    padding-bottom: 2rem;
    background-color: ${({ theme }) => theme.gray9};
`;

export const StyledLogoContainer = styled.div`
    display: flex;
    justify-content: center;
    padding: 0 5rem;
    padding-top: 2rem;
    background-color: ${({ theme }) => theme.gray8};
`;

export const StyledCoveredMemberContainer = styled.div`
    margin-bottom: 2rem;

    :last-child {
        margin-bottom: 0;
    }
`;

export const StyledPlanSectionHeader = styled.h4`
    background-color: ${({ theme }) => theme.gray8};
    padding: 1rem;
    margin: 0 !important;

    h5 {
        font-weight: bold;
    }

    a {
        font-weight: bold;
        :hover {
            text-decoration: none;
        }
        :focus {
            outline: none;
            text-decoration: none;
        }
    }
`;

export const StyledCenteredPlanSectionHeader = styled(StyledPlanSectionHeader)`
    text-align: center;
`;

export const StyledPlanSectionDataContainer = styled.div`
    background-color: ${({ theme }) => theme.gray9};
    padding: 2rem 1rem;
`;

export const StyledDisenrollActionContainer = styled(StyledCentered)`
    padding: 2rem 0;
`;

export const StyledPlanSummaryActionsContainer = styled.div``;

export const StyledModalButtonFooter = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;

    div {
        flex: 1;
    }
`;

export const StyledAPTCContainer = styled.div`
    background-color: ${({ theme }) => theme.gray9};
    border: 1px solid ${({ theme }) => theme.gray8};
    padding: 10px;
    margin: 1rem 0 2rem 0;
`;

export const StyledAlertMessage = styled(AlertMessage)`
    .gi-alert__info {
        padding: 1rem;
    }
`;

export const StyledAPTCSection2Container = styled.div`
    ul {
        margin-left: 3rem;

        li {
            margin-bottom: 1rem;
        }
    }
`;

export const StyledAPTCSliderContainer = styled.div`
    display: flex;
    align-items: center;

    .range-slider {
        touch-action: none;
        -webkit-tap-highlight-color: transparent;
        -webkit-user-select: none;
        user-select: none;
        cursor: pointer;
        display: block;
        position: relative;
        width: 100%;
        height: 20px;
        background: #ddd;
        background: #f8f7dd;
        border-radius: 5px;
        border: 1px solid;
    }

    .range-slider .range-slider__thumb {
        position: absolute;
        z-index: 3;
        top: 50%;
        width: 10px;
        height: 30px;
        transform: translate(-50%, -50%);
        border-radius: 0;
        box-shadow:
            1px 1px 1px #111,
            0px 0px 1px #1e1e1e;
        background: #e5e5df;
    }

    .range-slider .range-slider__thumb:focus {
        outline: 0;
    }

    .range-slider .range-slider__thumb:focus-visible {
        outline: 0;
    }

    .range-slider .range-slider__range {
        position: absolute;
        z-index: 1;
        transform: translate(0, -50%);
        top: 50%;
        width: 100%;
        height: 100%;
        background: #ffd077;
        border-radius: 5px;
    }

    #aptc-slider .range-slider__thumb[data-lower] {
        width: 0;
    }

    .currency-input {
        margin-top: 0;
        margin-right: 3rem;
    }

    .gi-input {
        margin-top: 0;
    }

    input[id='electedAptc'] {
        margin-top: 0;

        :focus {
            outline: none !important;
        }

        :focus-visible {
            outline: none !important;
        }
    }

    #aptc-credit {
        margin-left: 3rem;
        margin-right: 1rem;
        width: 55px;
    }
`;

export const StyledTextAreaContainer = styled.div`
    .gi-textarea__input {
        width: 100%;
    }
    .gi-textarea {
        margin-top: -1rem;
    }
`;

export const StyledDisenrollModalContainer = styled.div`
    .gi-radio_buttons__label {
        margin: 2rem 0;
    }
`;

export const StyledDisenrollmentConfirmationContent = styled.p`
    text-align: center;
    font-size: larger;
`;

export const StyledAptcSectionHeader = styled.h5<any>`
    font-size: ${({ fontSize }) => fontSize};
    font-weight: bold;
    line-height: 25px;
    text-rendering: optimizelegibility;
`;

export const StyledAptcModalBodyContainer = styled.div<any>`
    height: ${({ height }) => height};
    overflow-y: auto;
    align-content: center;
`;

export const StyledAptcTrHeader = styled.tr`
    background-color: ${({ theme }) => theme.gray10};
    border: none;
`;

export const StyledBorderlessTable = styled.table`
    border: none;
`;

export const StyledBorderlessTr = styled.tr`
    border: none;
`;

export const StyledBorderlessTd = styled.td`
    border: none;
    padding: 1rem 1rem 0 1rem;
`;

export const StyledVerticalAlignTd = styled(StyledBorderlessTd)`
    vertical-align: top;
`;

export const StyledAptcTdHeader = styled.td`
    border: none;
    padding: 1rem;
`;
